import React from 'react';
import styles from './dangerous-goods-row.module.less';

export const DangerousGoodsRow = ({ children }) => {
  return <div className={styles.row}>{children}</div>;
};
